import { apiContent } from "@/components/cms/items/schemas"
import { apiSeo } from "@/services/seos/schemas"
import { z } from "zod"

/**
 * apiPage
 */
export const apiPageState = z.union([z.literal("draft"), z.literal("published")])
export type ApiPageeState = z.infer<typeof apiPageState>
export const apiPage = z.object({
  id: z.string().uuid(),
  lock: z.boolean(),
  state: apiPageState,
  trackingId: z.string().uuid(),
  seoId: z.string(),
  seo: apiSeo,
  contentId: z.string().uuid(),
  content: apiContent,
  createdAt: z.string(),
  updatedAt: z.string(),
})
export type ApiPage = z.infer<typeof apiPage>
